import React from 'react';
import MarkdownWithViz from '../../MarkdownWithViz';

const reqPrefix = 'src/markdowns/longBeach/overivew';
const req = require.context('!raw-loader!../../../markdowns/longBeach/overview', false, /\.(md|jsx)$/);

export default function Overview() {
  return <MarkdownWithViz req={req} reqSource={req} reqPrefix={reqPrefix} />;
}
